<template>
      <a-card :bordered="false">
        <!-- 条件搜索 -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline">
            <a-row :gutter="48">
              <a-col :md="8" :sm="24">
                <a-form-item label="剧名" prop="videoName">
                  <a-input v-model="queryParam.videoName" placeholder="请输入" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="ID" prop="id">
                  <a-input v-model="queryParam.id" placeholder="请输入" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="分类" prop="tagIds">
                  <a-select v-model="queryParam.tagIds" placeholder="请选择" allow-clear>
                    <a-select-option v-for="(tag,index) in tagList" :key="index" :value="tag.id">
                      {{ tag.tagTitle }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="标签" prop="type">
                  <a-select v-model="queryParam.type" placeholder="请选择" allow-clear>
                    <a-select-option value="0">无标签</a-select-option>
                    <a-select-option value="1">NEW</a-select-option>
                    <a-select-option value="2">HOT</a-select-option>
                    <a-select-option value="3">首播</a-select-option>
                    <a-select-option value="4">独播</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="上映状态" prop="isRelease">
                  <a-select v-model="queryParam.isRelease" placeholder="请选择" allow-clear>
                    <a-select-option value="0">否</a-select-option>
                    <a-select-option value="1">是</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-button type="primary" @click="handleQuery">
                <a-icon type="search"/>
                查询
              </a-button>
              <a-button style="margin-left: 8px" @click="resetQuery">
                <a-icon type="redo"/>
                重置
              </a-button>
            </a-row>
          </a-form>
        </div>
        <!-- 在操作按钮区域添加保存按钮 -->
        <div class="table-operations">
            <a-button type="primary" @click="handleSave" :disabled="selectedRowKeys.length === 0">
                <a-icon type="save" />保存
            </a-button>
            <a-divider type="vertical" />
            <span class="selection-count" v-if="selectedRowKeys.length > 0">
                已选 {{ selectedRowKeys.length }} 条
            </span>
        </div>
        <!-- 操作 -->
        <div class="table-operations">
          <table-setting
            :style="{float: 'right'}"
            :table-size.sync="tableSize"
            v-model="columns"
            :refresh-loading="loading"
            @refresh="getList"/>
        </div>
        <!-- 数据展示 -->
        <a-table
          :loading="loading"
          :size="tableSize"
          rowKey="id"
          :columns="columns"
          :data-source="list"
          :row-selection="{selectedRowKeys: selectedRowKeys,onChange: onSelectChange,getCheckboxProps: getCheckboxProps}"
          :pagination="false"
          :scroll="{ x: 2500 }"
          :bordered="tableBordered"
        >
          <img slot="coverUrl" slot-scope="text, record" style="width: 48px;height: 48px;" :preview="record.coverUrl"
               v-image-preview :src="record.coverUrl">
          <span slot="sort" slot-scope="text, record">
            <a-input-number :min="0" :precision="0" @keyup.enter="editSort(record)"
                            v-model="record.sort"></a-input-number>
          </span>
          <span slot="trendingSort" slot-scope="text, record">
            <a-input-number :min="0" :precision="0" @keyup.enter="editTrendingSort(record)"
                            v-model="record.trendingSort"></a-input-number>
          </span>
        </a-table>
      </a-card>
  </template>
  
  <script>
  import {pageVideo, editSort, editTrendingSort,addPlaylistVideo} from '@/api/video/video'
  import {listTag} from '@/api/video/tag'
  import {tableMixin} from '@/store/table-mixin'
  
  export default {
    name: 'Video',
    props: {
        playlistId: {
            type: [Number, String],
            required: true
        },
        existingVideoIds: {
            type: Array,
            default: () => []
        }
    },
    components: {
    },
    mixins: [tableMixin],
    data() {
      return {
        playlistId: null,
        existingVideoIds: [],
        maxSelection: 15,
        list: [],
        selectedRowKeys: [],
        selectedRows: [],
        typeList: [],
        // 高级搜索 展开/关闭
        advanced: true,
        // 非单个禁用
        single: true,
        // 非多个禁用
        multiple: true,
        ids: [],
        loading: false,
        tagList: [],
        // 查询参数
        queryParam: {
          id: null,
          fakeLookNum: null,
          fakeCollectNum: null,
          limitNum: null,
          diamondPrice: null,
          goldPrice: null,
          describe: null,
          tagIds: null,
          type: null,
          isRelease: null,
          totalNum: null,
          videoName: null,
          coverUrl: null,
          pageNum: 1,
          pageSize: 10000
        },
        columns: [
          {
            title: 'ID',
            dataIndex: 'id',
            width: '50',
            align: 'center'
          },
          {
            title: '剧名',
            dataIndex: 'videoName',
            width: '200',
            align: 'center'
          },
          {
            title: '标签',
            dataIndex: 'type',
            width: '100',
            align: 'center',
            scopedSlots: {customRender: 'type'}
            // customRender: function (t, r, index) {
            //   if(t == 0) {
            //     return '无标签'
            //   }else if(t == 1) {
            //     return 'NEW'
            //   }else if(t == 2) {
            //     return 'Hot'
            //   }else if(t == 3) {
            //     return '首播'
            //   }else if(t == 4) {
            //     return '独播'
            //   }
            // }
          },
          {
            title: '封面图',
            dataIndex: 'coverUrl',
            align: 'center',
            width: '180',
            scopedSlots: {customRender: 'coverUrl'}
          },
          {
            title: '总集数',
            dataIndex: 'totalNum',
            width: '100',
            align: 'center'
          },
          {
            title: '分类',
            dataIndex: 'tagIds',
            width: '150',
            align: 'center'
          },
        ]
      }
    },
    filters: {},
    created() {
      this.getList()
      this.getTagList()
    },
    computed: {},
    watch: {},
    methods: {
    handleSave() {
        console.log('当前 playlistId:', this.playlistId)
        if (this.selectedRowKeys.length === 0) {
            this.$message.warning('请至少选择一条数据')
            return
        }
        const dataToSave = this.selectedRows.map(({ id, ...rest }) => ({
            ...rest,
            videoId: id,
            playlistId: this.playlistId
        }))
        addPlaylistVideo(dataToSave).then(response => {
            this.$message.success(`success`)
            this.selectedRowKeys = []
            this.selectedRows = []
            this.getList();
        }).catch(error => {
            this.$message.error('保存失败')
        })        
        // 保存后清空选择
        this.selectedRowKeys = []
        this.selectedRows = []
    },
        // 修改选择变化方法
    onSelectChange(selectedRowKeys, selectedRows) {
      // if (selectedRowKeys.length > this.maxSelection) {
      //   this.$message.warning(`最多只能选择${this.maxSelection}条数据`)
      //   return
      // }
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },

    getCheckboxProps(record) {
        console.log(this.existingVideoIds.getList)
        const isExisting = this.existingVideoIds.includes(record.id) // 已存在视频
        const isLimitReached = this.selectedRowKeys.length >= this.maxSelection &&
                                !this.selectedRowKeys.includes(record.id)

        return {
            props: {
            disabled: isExisting || isLimitReached
            }
        }
    },
    
      getTagList() {
        listTag().then(response => {
          this.tagList = response.data
        })
      },
      /** 查询短剧列表 */
      getList() {
        this.loading = true
        pageVideo(this.queryParam).then(response => {
          this.list = response.data.records
          for (let i = 0; i < this.list.length; i++) {
            console.log(this.list[i].type)
            this.list[i].typeList=this.list[i].type.toString().split(',')
            // if (this.list[i].type.length==1) {
            //   this.list[i].typeList=new Array(this.list[i].type)
            // } else {
            //   this.list[i].typeList=this.list[i].type.split(',')
            // }
  
          }
          this.loading = false
        })
      },
      editSort(record) {
        editSort({id: record.id, sort: record.sort}).then(response => {
          this.$message.success(
            '操作成功',
            3
          )
        })
      },
      editTrendingSort(record) {
        editTrendingSort({id: record.id, trendingSort: record.trendingSort}).then(response => {
          this.$message.success(
            '操作成功',
            3
          )
        })
      },
      /** 搜索按钮操作 */
      handleQuery() {
        this.queryParam.pageNum = 1
        this.getList()
      },
      /** 重置按钮操作 */
      resetQuery() {
        this.queryParam = {
          fakeLookNum: undefined,
          limitNum: undefined,
          diamondPrice: undefined,
          goldPrice: undefined,
          describe: undefined,
          tagIds: undefined,
          totalNum: undefined,
          videoName: undefined,
          coverUrl: undefined,
          pageNum: 1,
          pageSize: 10000
        }
        this.handleQuery()
      },
      onShowSizeChange(current, pageSize) {
        this.queryParam.pageSize = pageSize
        this.getList()
      },
      changeSize(current, pageSize) {
        this.queryParam.pageNum = current
        this.queryParam.pageSize = pageSize
        this.getList()
      },
      toggleAdvanced() {
        this.advanced = !this.advanced
      },
    }
  }
  </script>
<style>
.table-operations {
  margin-bottom: 16px;
}
.selection-count {
  margin-left: 8px;
  color: rgba(0, 0, 0, 0.45);
}
</style>